export default {"src":"/_next/static/media/GTLS.ac0f8944.svg","height":18,"width":18};